import { CLEAR_STORE, LOAD_MOBILE_VALIDATIONS } from '../../action-contants';

export default function mobileValidationReducer(state = {}, action) {
  switch (action.type) {
    case CLEAR_STORE: {
      return {};
    }
    case LOAD_MOBILE_VALIDATIONS:
      return { ...state, ...action.data };
    default:
      return state;
  }
}
